import {
  IssueFilteringDtoOptions,
  IssueSortingDtoOptions,
  Issues200Response,
  useApi,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useQuery } from '@tanstack/react-query';

export type ListIssueQueryParameters = {
  sort?: IssueSortingDtoOptions;
  filter?: IssueFilteringDtoOptions;
  page?: number;
  limit?: number;
};

export function useIssues(props: ListIssueQueryParameters) {
  const { page = 0, limit = 10, sort = {}, filter = {} } = props;

  const api = useApi();

  return useQuery<Issues200Response, ExtendedAxiosError>({
    queryKey: ['issues', sort, filter, page, limit],
    queryFn: () =>
      api.issuesApi.issues(sort, filter, page, limit).then((r) => r.data),
    meta: {
      handleError: true,
    },
  });
}
